import { ICoreContext, IDateFormatOptions } from '@msdyn365-commerce/core';
import React from 'react';
import { ProductHeaderInput } from './../coc-c-invoice-details.view';
import { IInvoiceDetailsViewProps } from '@msdyn365-commerce-modules/invoice-details/src/modules/invoice-details/./invoice-details';

import moment from 'moment';

const formatShortDate = (context: ICoreContext, date: Date | undefined) => {
    if (date === undefined) {
        return '';
    }
    const dateOptions: IDateFormatOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
    return context.cultureFormatter.formatDate(date, dateOptions);
};

export const InvoiceDetailsHeader: React.FC<{
    className: string;
    id: string;
    data: ProductHeaderInput;
    properties: IInvoiceDetailsViewProps;
}> = (props): JSX.Element => {
    // const invoiceNumberText = props.properties.resources.invoiceIdLabel.replace('{0}', props.data.invoiceid);
    const className = 'msc-invoice-details';
    const hearderClassName = `${className}__header`;
    //const headerInvoiceIdClassName = `${hearderClassName}__invoice-id`;
    const invoiceInfoContainerClassName = `${hearderClassName}__invoice-info-container`;

    const orderInfoContainerClassName = `${invoiceInfoContainerClassName}__order-info-container`;

    const orderInfoClassName = `${orderInfoContainerClassName}__order-info`;
    const detailClassName = `${orderInfoClassName}__details`;
    const orderDateClassName = `${detailClassName}__order-date`;

    const orderDate = formatShortDate(props.properties.context, props.data.invoiceDate);
    const orderCreatedDate = moment(orderDate, 'YYYY-MM-DD').format('MMMM DD, YYYY');

    return (
        <div className={className}>
            <div className={hearderClassName}>
                {/* <div className={headerInvoiceIdClassName}>{invoiceNumberText}</div> */}
                <div className={invoiceInfoContainerClassName}>
                    <div className={orderInfoContainerClassName}>
                        <div className={orderInfoClassName}>
                            <div className={detailClassName}>
                                <div className={orderDateClassName}>{orderCreatedDate}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
